
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

export const useEmailConfirmation = (email: string, setLoading: (loading: boolean) => void) => {
  const { toast } = useToast();

  const handleResendConfirmation = async () => {
    setLoading(true);
    try {
      // Get the full domain for the redirect
      const origin = window.location.origin;
      const redirectUrl = `${origin}/auth/callback`;
      
      const { data, error } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: redirectUrl,
        }
      });

      if (error) throw error;

      console.log("Confirmation email resent:", data);
      toast({
        title: "Email envoyé",
        description: "Un nouveau lien de confirmation vous a été envoyé par email. Vérifiez aussi vos spams.",
      });
    } catch (error: any) {
      console.error("Error resending confirmation:", error);
      toast({
        title: "Erreur",
        description: error.message,
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const renderResendButton = () => (
    <Button variant="outline" onClick={handleResendConfirmation}>
      Renvoyer l'email de confirmation
    </Button>
  );

  return {
    handleResendConfirmation,
    renderResendButton
  };
};
